import type { GetExaminationResponse } from 'src/types/examination';

import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

import { LessonType } from 'src/types/examination/examination.types';

export function useExaminationDetails(examinationId?: number) {
  const { data, error, isLoading, mutate } = useSWR<GetExaminationResponse>(
    examinationId ? ['examination', examinationId] : null,
    () => fetcher<GetExaminationResponse>(endpoints.examination.details(examinationId!)),
    {
      shouldRetryOnError: (err) => {
        if (err?.response?.status >= 400 && err?.response?.status < 500) {
          return false;
        }
        return true;
      },
    }
  );

  const examination = data
    ? {
        ...data,
        lessonType:
          data.lesson?.type && Object.values(LessonType).includes(data.lesson.type as LessonType)
            ? (data.lesson.type as LessonType)
            : LessonType.STANDARD,
      }
    : undefined;

  return {
    examination,
    isLoading,
    error,
    refetch: mutate,
  };
}
